import { Component, Input } from '@angular/core';

import { MyModal } from './../../../../../common/my-modal/my-modal.component';
import { HtmlService } from './../../../../../../services/html.service';

@Component({
    selector: 'ipp-speaking-sample-response',
    template: require('./ipp-speaking-sample-response.component.html')
})
export class IppSpeakingSampleResponseComponent {
    @Input() title: string;
    @Input() resourceId: number;
    private modalContent = '<div class="speaking-sample-response"><audio controls><source src="{{srcUrl}}" type="video/mp4">Your browser does not support the audio element.</audio></div>';

    constructor(
        private myModal: MyModal,
        private htmlService: HtmlService
    ) {

    }

    showDialog() {
        var srcUrl = this.htmlService.getResourceUrl(this.resourceId);
        this.modalContent = this.modalContent.replace("{{srcUrl}}", `${srcUrl}`);
        this.myModal.showRegularDlg(this.title, this.modalContent, [
            { label: "Close", style: "btn-primary" }
        ]);
    }
}


// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-speaking-sample-response/ipp-speaking-sample-response.component.ts